var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 32H32C14.31 32 0 46.31 0 64v64c0 8.812 7.188 16 16 16H32v288C32 458.5 53.49 480 80 480h352c26.51 0 48-21.49 48-48v-288h16C504.8 144 512 136.8 512 128V64C512 46.31 497.7 32 480 32zM464 432c0 17.64-14.36 32-32 32h-352c-17.64 0-32-14.36-32-32v-288h416V432zM496 128h-480V64c0-8.82 7.178-16 16-16h448c8.822 0 16 7.18 16 16V128zM168 256h176C348.4 256 352 252.4 352 248S348.4 240 344 240h-176C163.6 240 160 243.6 160 247.1S163.6 256 168 256z"
  })));
};

export default SvgPackage;